import React from "react";

const PALETTE = {
    approved: { bg: "#dcfce7", color: "#166534", label: "Подтверждено" },
    suggested: { bg: "#fef9c3", color: "#854d0e", label: "Предложено" },
    ignored: { bg: "#f1f5f9", color: "#64748b", label: "Игнорируется" },
    mapped: { bg: "#dcfce7", color: "#166534", label: "Смаплено" },
    unmapped: { bg: "#fee2e2", color: "#991b1b", label: "Не смаплено" },
};

const badge = {
    display: "inline-block",
    padding: "2px 10px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: 700,
    whiteSpace: "nowrap",
};

// Единая плашка статуса маппинга -- у Prom тот же статус то выводится сырой
// строкой (`{row.status}`), то булевым текстом «Активна»/«Отключена» в трёх
// разных местах без общего компонента. См. docs/rozetka_stage1_catalog_stock_plan.md §6.3.
const MappingStatusBadge = ({ status, children }) => {
    const entry = PALETTE[status] || { bg: "#e2e8f0", color: "#334155", label: status || "—" };
    return <span style={{ ...badge, background: entry.bg, color: entry.color }}>{children || entry.label}</span>;
};

export default MappingStatusBadge;
